<template>
  <div class="verify-shipping-container">
    <!-- Opaque background -->
    <div class="verify-shipping-modal-background" />

    <!-- Inner body -->
    <div class="verify-inner-container">
      <img
        :src="require('@/assets/checkout/verify-address.svg')"
        alt="Verify Address Icon"
        class="verify-address-icon"
      >
      <h2>Verify Shipping Address</h2>
      <label class="subtitle">We found an address similar to the one you entered, please choose which
        one you would like to use.</label>

      <div class="verify-addresses-container">
        <!-- Loop through addresses -->
        <div
          v-for="(address, index) in shippingAddresses"
          :key="address.id"
          class="ship-address"
        >
          <!-- Address Line 1 -->
          <div
            class="address-section1"
            :class="{
              'top-left': index == 0,
              'bottom-left': index == shippingAddresses.length - 1,
              'middle-left:':
                index != 0 && index != shippingAddresses.length - 1,
            }"
          >
            <input
              v-model="radioPicked"
              type="radio"
              :value="index"
            >
            <label>{{ address.street_1 }}</label>
            <div v-show="address.street_2.length">
              <label>{{ address.street_2 }}</label>
            </div>
            <div v-show="address.street_3.length">
              <label>{{ address.street_3 }}</label>
            </div>
          </div>

          <!-- City -->
          <div class="address-section2">
            <label>{{ address.city }}</label>
          </div>

          <!-- State, Postal -->
          <div
            class="address-section3"
            :class="{
              'top-right': index == 0,
              'bottom-right': index == shippingAddresses.length - 1,
              'middle-right:':
                index != 0 && index != shippingAddresses.length - 1,
            }"
          >
            <label class="state">{{ address.state }}</label>
            <label>{{ address.zip }}</label>
          </div>
        </div>
      </div>

      <button
        class="continue-btn"
        @click="confirmShipping()"
      >
        Confirm Address
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "VerifyShippingComponent",
  components: {},
  props: ["shippingAddresses"],
  data() {
    return {
      radioPicked: 0,
    };
  },

  computed: {},

  mounted() {},

  methods: {
    confirmShipping() {
      this.$emit("clicked", this.radioPicked);
    },
  },
};
</script>

<style>
.verify-address-icon {
  width: 4em;
  height: 4em;
  margin: 1em auto;
}
</style>
